import React from "react";
import PropTypes from "prop-types";
import {
  Text0 as Text,
  Text4,
  Text3,
  Text2,
  MediumOutlineButton,
  Div
} from "components/Base";

const ContactSelectionView = ({ contacts, onSelectContact, onBack, error }) => (
  <Div
    height={1}
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}
  >
    <Div
      display="column"
      mx="auto"
      my={6}
      p={4}
      backgroundColor="white"
      borderRadius={4}
      style={{
        maxWidth: "750px",
        width: "100%",
        border: "1px solid #e6e6e6",
        boxShadow: "0 8px 16px rgba(0,0,0,0.15)"
      }}
    >
      <Div
        display="column"
        mb={4}
        style={{
          gap: "4px",
          backgroundColor: "#9f50f2",
          color: "white",
          padding: "16px 12px"
        }}
      >
        <Text4 bold color="white">
          Select Contact
        </Text4>
        <Text3 color="neutral1">
          Multiple contacts were found for this email/username. Please select
          the appropriate contact to continue.
        </Text3>
      </Div>

      <Div
        display="column"
        style={{
          gap: "16px",
          maxHeight: "450px",
          overflowY: "auto",
          alignItems: "center"
        }}
      >
        {error && (
          <Div
            py={3}
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #ff6b6b",
              borderRadius: "4px",
              padding: "12px",
              width: "98%",
              textAlign: "center"
            }}
          >
            <Text2 color="#ff6b6b">{error}</Text2>
          </Div>
        )}
        {contacts.map(contact => (
          <MediumOutlineButton
            key={contact.id}
            onClick={() => onSelectContact(contact.id, contact.email)}
            display="column"
            style={{
              width: "98%",
              paddingTop: "12px",
              paddingBottom: "12px",
              minHeight: "80px",
              transition: "all 0.2s ease-in-out",
              ":hover": {
                borderColor: "#9b5de2",
                transform: "scale(1.02)"
              }
            }}
          >
            <Text3 mb={1}>
              {contact.first_name} {contact.last_name}
            </Text3>
            <Text color="neutral6" mb={1}>
              Email: {contact.email}
            </Text>
            <Text color="neutral6">
              Associated with: {contact.accounts.join(", ")}
            </Text>
          </MediumOutlineButton>
        ))}
      </Div>
      <Div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "20px 0 0 0"
        }}
      >
        <MediumOutlineButton
          onClick={onBack}
          style={{
            width: "100px",
            height: "40px",
            backgroundColor: "#9f50f2",
            color: "white"
          }}
        >
          ← Back
        </MediumOutlineButton>
      </Div>
    </Div>
  </Div>
);

ContactSelectionView.propTypes = {
  contacts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      accounts: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  ).isRequired,
  onSelectContact: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  error: PropTypes.string
};

export default ContactSelectionView;
